import React from 'react'
import Slider from "react-slick";

import clientOne from '../images/clients/1.png'
import clientTwo from '../images/clients/2.png'
import clientThree from '../images/clients/3.png'
import clientFour from '../images/clients/4.png'
import clientFive from '../images/clients/5.png'
import clientSix from '../images/clients/6.png'
import clientSeven from '../images/clients/7.png'
import clientEight from '../images/clients/8.png'
import clientNine from '../images/clients/9.png'
import clientTen from '../images/clients/10.png'
import clientElven from '../images/clients/11.png'
import clientTewel from '../images/clients/12.png'
import clientThritin from '../images/clients/13.png'
import clientFourtin from '../images/clients/14.png'
import clientFiftin from '../images/clients/15.png'
import clientSixtin from '../images/clients/16.png'
import clientSeventin from '../images/clients/17.png'
import clientEightin from '../images/clients/18.png'
import clientNinetin from '../images/clients/19.png'
import clientTwenty from '../images/clients/20.png'
import clientTwentyOne from '../images/clients/21.png'
import clientTwentyTwo from '../images/clients/22.png'
import clientTwentyThree from '../images/clients/23.png'
import clientTwentyFour from '../images/clients/24.png'
import clientTwentyFive from '../images/clients/25.png'



const Clients = () => {

    const settingsOne = {
        className: "center",
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 4000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        swipeToSlide: true,
        afterChange: function (index) {
            console.log(`Slider Changed to: ${index + 1}, background: #222; color: #bada55`);
        },
        responsive: [
            {
                breakpoint: 2500,
                settings: {
                    slidesToShow: 4,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: 5,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "30px",
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "20px",
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "15px",
                }
            }
        ]
    };


    return (
        <>

            <div>
                <div className="slider-container">
                    <Slider {...settingsOne} className='px-4 py-4 md:py-8'>

                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientOne} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwo} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientThree} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientFour} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientFive} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientSix} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientSeven} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientEight} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientNine} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTen} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientElven} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTewel} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientThritin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientFourtin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientFiftin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientSixtin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientSeventin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientEightin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientNinetin} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwenty} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwentyOne} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwentyTwo} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwentyThree} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwentyFour} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                        <div className='px-2 md:px-5' data-aos='fade-up' data-aos-duration="1000">
                            <div className='group relative overflow-hidden border md:border-2 border-gray-500  rounded-lg'>
                                <img src={clientTwentyFive} className='w-full drop-shadow-lg object-cover  group-hover:scale-105 duration-300' alt="" />
                            </div>
                        </div>
                     

                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Clients